import React, { useState } from "react"
import { useSelector } from "react-redux"
import {
  Container,
} from "react-bootstrap"
import { roleCheck } from "utils/index"
import {
  ADMIN,
  DRAFTING_MANAGER,
  DRAFTING_3D_MANAGER
} from "utils/constants"
import { getCurrentRole, getCurrentUser } from "../../reducers"
import TimeSpentReportsTab from "./components/TimeSpentReportsTab"
import CompletedJobsOverview from "./CompletedJobsOverview"
import FutureReport from "./FutureReport"
import DraftingOverview from "./DraftingOverview"
import RegisteredSurveyorOverview from "./RegisteredSurveyorOverview"

const TimeSpentReport = () => {
  const currentUser = useSelector(getCurrentUser)
  const currentRole = useSelector(getCurrentRole)
  const systemRole = currentUser.attributes.role
  const currentTeamRole = currentUser.attributes.current_team_role || []
  const isAdmin = currentRole.includes(ADMIN)
  const isDraftingManager = roleCheck(systemRole, currentTeamRole, DRAFTING_MANAGER) || roleCheck(systemRole, currentTeamRole, DRAFTING_3D_MANAGER)
  const canAccess = isAdmin || isDraftingManager

  if (!canAccess) window.location = "/"

  const defaultTab = () => (isAdmin ? "Completed Job Overview" : "Drafting")
  const tabOptions = isAdmin
    ? ["Completed Job Overview", "Future Report", "Drafting", "Registered Surveyors"]
    : ["Drafting"]
  const [activeTab, setActiveTab] = useState(defaultTab())

  return (
    <Container fluid className="">
      <div className="container-inner">
        <div className="container justify-content-between align-items-center header-tabs-container p-0 m-0">
          <h1 className="d-flex align-items-center">
            <i className="fas fa-clock mr-2"></i>
            Time Spent Report
          </h1>
          <TimeSpentReportsTab activeTab={activeTab} setActiveTab={setActiveTab} tabOptions={tabOptions} />
        </div>
        { activeTab === "Completed Job Overview" && <CompletedJobsOverview /> }
        { activeTab === "Future Report" && <FutureReport /> }
        { activeTab === "Drafting" && <DraftingOverview /> }
        { activeTab === "Registered Surveyors" && <RegisteredSurveyorOverview /> }
      </div>
    </Container>
  )
}

export default TimeSpentReport